import {
    hide_smoothen_options_modal,
    showing_smoothen_options_modal,
} from '../../state';
import { Dialog } from '@phi/components';
import { defineComponent, h } from 'vue';
import { SmoothenStrength } from '../smoothen-strength';

export const SmoothenOptionsModal = defineComponent({
    setup() {
        return () => h(Dialog, {
            title: 'Set smoothen strength',
            show: showing_smoothen_options_modal.value,
            'onUpdate:show': x => showing_smoothen_options_modal.value = x,
            id: 'smoothen-options-modal',
            onClose: hide_smoothen_options_modal,
            confirm_label: null,
        }, () => h(SmoothenStrength));
    },
});
